/**
 * Rilevamento file PDF
 */

const PDF_MIME_TYPE = 'application/pdf';
const PDF_EXTENSION = '.pdf';

/**
 * Verifica se un file è un PDF basandosi su MIME type o estensione.
 *
 * @param file - Il file da verificare
 * @returns true se il file sembra essere un PDF
 */
export function isPdfFile(file: File): boolean {
  return file.type === PDF_MIME_TYPE || file.name.toLowerCase().endsWith(PDF_EXTENSION);
}
